// import React, { useState, useEffect } from 'react';
// import { Container, Button, Form } from 'react-bootstrap';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';

// const BankDetailsForm = () => {
//   const BaseUrl = process.env.REACT_APP_API;
//   const navigate = useNavigate();
//   const [bankAccounts, setBankAccounts] = useState([]);

//   useEffect(() => {
//     const fetchBankAccounts = async () => {
//       try {
//         const jwtToken = sessionStorage.getItem("authToken");
//         if (!jwtToken) {
//           throw new Error("JWT token not found in local storage");
//         }

//         const tokenValidationResponse = await axios.post(
//           `${BaseUrl}/validate-token`,
//           { token: jwtToken }
//         );
//         if (!tokenValidationResponse.data.valid) {
//           throw new Error("Token validation failed or expired");
//         }

//         const response = await axios.get(`${BaseUrl}/getIndividualBankaccounts`, {
//           headers: {
//             Authorization: `Bearer ${jwtToken}`,
//           },
//         });
//         setBankAccounts(response.data);
//       } catch (error) {
//         console.error(error.message || "Error fetching bank accounts");
//       }
//     };

//     fetchBankAccounts();
//   }, [BaseUrl]);

//   const handleSubmit = () => {
//     navigate("/dashboard");
//   };


//   return (
//     <Container className="mt-5">
//       <Form>
//         <fieldset style={{ padding: "20px", display: "block" }}>
//           <div
//             style={{
//               padding: "20px",
//               borderRadius: "10px",
//               boxShadow: "0px 0px 20px #748292",
//               transition: "all 0.5s ease-in-out",
//             }}
//           >
//             <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
//               Bank Details
//             </h6>
//             <hr style={{ margin: "5px", border: "1px solid #748292", width: "100%" }} />

//             {bankAccounts.length > 0 ? (
//               bankAccounts.map((account, index) => (
//                 <div key={index}>
//                   <h6>Bank Account {index + 1}</h6>
//                   {/* Name of Bank */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">Name of Bank</label>
//                     <div className="col-md-9">
//                       <input
//                         type="text"
//                         className="form-control shadow-sm"
//                         placeholder="Enter the name of the bank"
//                         value={account.bank_name || ''}
//                         readOnly
//                       />
//                     </div>
//                   </div>

//                   {/* Account Name */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">Account Name</label>
//                     <div className="col-md-9">
//                       <input
//                         type="text"
//                         className="form-control shadow-sm"
//                         placeholder="Enter the account name"
//                         value={account.account_name || ''}
//                         readOnly
//                       />
//                     </div>
//                   </div>

//                   {/* Account Number */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">Account Number</label>
//                     <div className="col-md-9">
//                       <input
//                         type="text"
//                         className="form-control shadow-sm"
//                         placeholder="Enter the account number"
//                         value={account.account_number || ''}
//                         readOnly
//                       />
//                     </div>
//                   </div>

//                   {/* IBAN */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">IBAN</label>
//                     <div className="col-md-9">
//                       <input
//                         type="text"
//                         className="form-control shadow-sm"
//                         placeholder="Enter the IBAN"
//                         value={account.iban || ''}
//                         readOnly
//                       />
//                     </div>
//                   </div>

//                   {/* SWIFT */}
//                   <div className="row mb-3">
//                     <label className="col-md-3 col-form-label text-start">SWIFT</label>
//                     <div className="col-md-9">
//                       <input
//                         type="text"
//                         className="form-control shadow-sm"
//                         placeholder="Enter the SWIFT code"
//                         value={account.swift || ''}
//                         readOnly
//                       />
//                     </div>
//                   </div>
//                 </div>
//               ))
//             ) : (
              
//               <h6>No Bank Details Added</h6>
//             )}

//             {/* Submit Button */}
//             {/* <div className="text-end">
//               <button type="submit" className="btn btn-primary" onClick={handleSubmit}>
//                 Submit
//               </button>
//             </div> */}
//           </div>
//         </fieldset>
//       </Form>
//     </Container>
//   );
// };

// export default BankDetailsForm;
import React, { useState, useEffect } from 'react';
import { Container, Button, Form, Modal, Card, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import { toast, ToastContainer } from "react-toastify";

const BankDetailsComponent = () => {
  const BaseUrl = process.env.REACT_APP_API;
  const [bankAccounts, setBankAccounts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [bankAccount, setBankAccount] = useState({
    bank_name: '',
    address_1: '',
    address_2: '',
    country: '',
    city: '',
    account_name: '',
    account_number: '',
    iban: '',
    swift: ''
  });


  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch(`${BaseUrl}/countries`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setCountries(data);
      } catch (error) {
        console.error("Failed to fetch countries:", error);
      }
    };

    fetchCountries();
  }, [BaseUrl]);

  // Fetch existing bank accounts and countries
  useEffect(() => {
    const fetchData = async () => {
      try {
        const jwtToken = sessionStorage.getItem("authToken");
        if (!jwtToken) {
          throw new Error("JWT token not found in session storage");
        }

        const tokenValidationResponse = await axios.post(
          `${BaseUrl}/validate-token`,
          { token: jwtToken }
        );
        if (!tokenValidationResponse.data.valid) {
          throw new Error("Token validation failed or expired");
        }

        // Fetch bank accounts
        const bankResponse = await axios.get(`${BaseUrl}/getIndividualBankaccounts`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        setBankAccounts(bankResponse.data);

      } catch (error) {
        console.error(error.message || "Error fetching data");
      }
    };

    fetchData();
  }, [BaseUrl]);

  // Handle input changes for the bank account
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBankAccount({
      ...bankAccount,
      [name]: value
    });
  };

  // Submit bank account
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const jwtToken = sessionStorage.getItem("authToken");
      if (!jwtToken) {
        setLoading(false);
        throw new Error("JWT token not found in session storage");
      }

      const tokenValidationResponse = await axios.post(
        `${BaseUrl}/validate-token`,
        { token: jwtToken }
      );
      if (!tokenValidationResponse.data.valid) {
        setLoading(false);
        throw new Error("Token validation failed or expired");
      }

      await axios.post(`${BaseUrl}/submitIndividualBankaccounts`, [bankAccount], {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "application/json",
        },
      });
      
      // Refresh the bank accounts list
      const response = await axios.get(`${BaseUrl}/getIndividualBankaccounts`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      setBankAccounts(response.data);
      
      setLoading(false);
      toast.success("Bank Account Added Successfully!");
      setShowModal(false);
      setBankAccount({
        bank_name: '',
        address_1: '',
        address_2: '',
        country: '',
        city: '',
        account_name: '',
        account_number: '',
        iban: '',
        swift: ''
      });
    } catch (err) {
      console.error("Error submitting the form:", err);
      toast.error(err.message || "Error submitting bank details");
      setLoading(false);
    }
  };

  const getCountryName = (countryId) => {
    const country = countries.find(c => c.NumCode == countryId);
    return country ? country.Country : countryId;
  };

  return (
    <Container className="mt-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>Bank Accounts</h4>
        <Button variant="primary" onClick={() => setShowModal(true)}>
          Add Bank Account
        </Button>
      </div>

      {bankAccounts.length > 0 ? (
        bankAccounts.map((account, index) => (
          <Card key={index} className="mb-4 shadow-sm">
            <Card.Body>
              <Card.Title>Bank Account {index + 1}</Card.Title>
              
              <Form.Group as={Row} className="mb-3">
                <Form.Label column md={3} className="text-start">Name of Bank</Form.Label>
                <Col md={9}>
                  <Form.Control
                    type="text"
                    readOnly
                    value={account.bank_name || ''}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-3">
                <Form.Label column md={3} className="text-start">Address (1)</Form.Label>
                <Col md={9}>
                  <Form.Control
                    type="text"
                    readOnly
                    value={account.address_1 || ''}
                  />
                </Col>
              </Form.Group>

              {account.address_2 && (
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column md={3} className="text-start">Address (2)</Form.Label>
                  <Col md={9}>
                    <Form.Control
                      type="text"
                      readOnly
                      value={account.address_2 || ''}
                    />
                  </Col>
                </Form.Group>
              )}

              <Form.Group as={Row} className="mb-3">
                <Form.Label column md={3} className="text-start">Country</Form.Label>
                <Col md={9}>
                  <Form.Control
                    type="text"
                    readOnly
                    value={getCountryName(account.country)}
                    // value={countries.find(c => c.NumCode === account.country)?.Country || account.country || ''}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-3">
                <Form.Label column md={3} className="text-start">City</Form.Label>
                <Col md={9}>
                  <Form.Control
                    type="text"
                    readOnly
                    value={account.city || ''}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-3">
                <Form.Label column md={3} className="text-start">Account Name</Form.Label>
                <Col md={9}>
                  <Form.Control
                    type="text"
                    readOnly
                    value={account.account_name || ''}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-3">
                <Form.Label column md={3} className="text-start">Account Number</Form.Label>
                <Col md={9}>
                  <Form.Control
                    type="text"
                    readOnly
                    value={account.account_number || ''}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-3">
                <Form.Label column md={3} className="text-start">IBAN</Form.Label>
                <Col md={9}>
                  <Form.Control
                    type="text"
                    readOnly
                    value={account.iban || ''}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} className="mb-3">
                <Form.Label column md={3} className="text-start">SWIFT Code</Form.Label>
                <Col md={9}>
                  <Form.Control
                    type="text"
                    readOnly
                    value={account.swift || ''}
                  />
                </Col>
              </Form.Group>
            </Card.Body>
          </Card>
        ))
      ) : (
        <Card className="text-center p-4 shadow-sm">
          <Card.Body>
            <Card.Text>No bank accounts added yet</Card.Text>
          </Card.Body>
        </Card>
      )}

      {/* Add Bank Account Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Add Bank Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col xl={12}>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column md={3}>
                    Name of Bank
                  </Form.Label>
                  <Col md={9}>
                    <Form.Control
                      type="text"
                      name="bank_name"
                      value={bankAccount.bank_name || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                  <Form.Label column md={3}>
                    Address (1)
                  </Form.Label>
                  <Col md={9}>
                    <Form.Control
                      type="text"
                      name="address_1"
                      value={bankAccount.address_1 || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                  <Form.Label column md={3}>
                    Address (2) <small className="text-muted">Optional</small>
                  </Form.Label>
                  <Col md={9}>
                    <Form.Control
                      type="text"
                      name="address_2"
                      value={bankAccount.address_2 || ""}
                      onChange={handleInputChange}
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                  <Form.Label column md={3}>
                    Country
                  </Form.Label>
                  <Col md={9}>
                    <Form.Select
                      name="country"
                      value={bankAccount.country || ""}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select</option>
                      {countries.map((country) => (
                        <option
                          key={country.NumCode}
                          value={country.NumCode}
                        >
                          {country.Country}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                  <Form.Label column md={3}>
                    City
                  </Form.Label>
                  <Col md={9}>
                    <Form.Control
                      type="text"
                      name="city"
                      value={bankAccount.city || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                  <Form.Label column md={3}>
                    Account Name
                  </Form.Label>
                  <Col md={9}>
                    <Form.Control
                      type="text"
                      name="account_name"
                      value={bankAccount.account_name || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                  <Form.Label column md={3}>
                    Account Number
                  </Form.Label>
                  <Col md={9}>
                    <Form.Control
                      type="text"
                      name="account_number"
                      value={bankAccount.account_number || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                  <Form.Label column md={3}>
                    IBAN
                  </Form.Label>
                  <Col md={9}>
                    <Form.Control
                      type="text"
                      name="iban"
                      value={bankAccount.iban || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} className="mb-3">
                  <Form.Label column md={3}>
                    SWIFT
                  </Form.Label>
                  <Col md={9}>
                    <Form.Control
                      type="text"
                      name="swift"
                      value={bankAccount.swift || ""}
                      onChange={handleInputChange}
                      required
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-end mt-3">
              <Button variant="secondary" onClick={() => setShowModal(false)} className="me-2">
                Cancel
              </Button>
              <Button variant="primary" type="submit" disabled={loading}>
                {loading ? 'Submitting...' : 'Submit'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <ToastContainer position="top-right" autoClose={3000} />

    </Container>
    
  );
};

export default BankDetailsComponent;